module.exports = __webpack_public_path__ + "static/media/add visitor entries.074c1973.svg";